import { derived } from 'svelte/store';
import { page } from '$app/stores';
import type { ProductFilter } from '$gql/storefront/schemas';
import { decodePriceRange } from '$lib/utils/shopify/priceRange';

export const urlProductFilters = derived(page, ({ url: { searchParams } }) => {
  const keys = [...new Set(Array.from(searchParams.keys()))];

  const prefixes = {
    variantOption: 'filter.v.option.',
    metafield: 'filter.p.m.'
  };

  return keys.reduce<ProductFilter[]>((result, key) => {
    if (key === 'filter.p.product_type') {
      searchParams.getAll(key).map((paramValue) => {
        result.push({
          productType: paramValue
        });
      });
    } else if (key === 'filter.p.vendor') {
      searchParams.getAll(key).map((paramValue) => {
        result.push({
          productVendor: paramValue
        });
      });
    } else if (key === 'filter.v.availability') {
      searchParams.getAll(key).map((paramValue) => {
        result.push({
          available: paramValue === 'In stock'
        });
      });
    } else if (key.startsWith(prefixes.variantOption)) {
      searchParams.getAll(key).map((paramValue) => {
        result.push({
          variantOption: {
            name: key.replace(prefixes.variantOption, ''),
            value: paramValue
          }
        });
      });
    } else if (key.startsWith(prefixes.metafield)) {
      searchParams.getAll(key).map((paramValue) => {
        const [namespace, namespaceKey] = key.replace(prefixes.metafield, '').split('.', 2);
        result.push({
          productMetafield: {
            namespace,
            key: namespaceKey,
            value: paramValue
          }
        });
      });
    } else if (key === 'filter.v.price') {
      let price: ReturnType<typeof decodePriceRange>;

      searchParams.getAll(key).forEach((paramValue) => {
        const p = decodePriceRange(paramValue);

        if (!price) {
          price = p;
        }

        if (p?.min) {
          if (price?.min && price.min > p.min) {
            price = { ...price, min: p.min };
          }
        } else {
          price = { ...price, min: undefined };
        }

        if (p?.max) {
          if (price?.max && price.max < p.max) {
            price = { ...price, max: p.max };
          }
        } else {
          price = { ...price, max: undefined };
        }
      });

      result.push({
        price
      });
    }

    return result;
  }, []);
});
